module.exports = __webpack_public_path__ + "616ae909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_ordering_hourly_clock.png
// module id = 1776
// module chunks = 0